import { render, staticRenderFns } from "./taskConfigList.vue?vue&type=template&id=1f9e194d&scoped=true"
import script from "./taskConfigList.vue?vue&type=script&lang=js"
export * from "./taskConfigList.vue?vue&type=script&lang=js"
import style0 from "./taskConfigList.vue?vue&type=style&index=0&id=1f9e194d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e194d",
  null
  
)

export default component.exports